import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DefaultComponent} from './layout/default/default.component';
import {AuthGuard} from 'phd-akita-session';
import {LandingComponent} from './layout/landing/landing.component';
import {LoginPageComponent} from './layout/login-page/login-page.component';
import {NotFoundPageComponent} from './layout/not-found-page/not-found-page.component';
import {SsoRedirectComponent} from './core/sso-redirect/sso-redirect.component';
import {PdfViewerComponent} from './shared/pdf-viewer/pdf-viewer.component';

const routes: Routes = [
  {
    path: '', component: DefaultComponent, data: {breadcrumb: 'Home'},
    canActivate: [AuthGuard], canActivateChild: [AuthGuard],
    children: [
      {path: '', redirectTo: 'home', pathMatch: 'full'},
      {path: 'pdf', component: PdfViewerComponent},
      {path: 'home', component: LandingComponent, data: {breadcrumb: '首頁'}},
      {
        path: 'system',
        data: {breadcrumb: '系統設定'},
        loadChildren: () => import('./modules/system/system.module').then(m => m.SystemModule)
      },
      {
        path: 'account',
        data: {breadcrumb: '會計'},
        loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule)
      },
      {
        path: 'factory',
        data: {breadcrumb: '內地廠用'},
        loadChildren: () => import('./modules/factory/factory.module').then(m => m.FactoryModule)
      },
      {
        path: 'management',
        data: {breadcrumb: '管理'},
        loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule)
      },
      {
        path: 'branch',
        data: {breadcrumb: '門市操作'},
        loadChildren: () => import('./modules/branch/branch.module').then(m => m.BranchModule)
      },
      {
        path: 'bi-report',
        data: {breadcrumb: '報表'},
        loadChildren: () => import('./modules/bi-report/bi-report.module').then(m => m.BiReportModule)
      },
    ]
  },
  {path: 'sso/:parent/:func/:token', component: SsoRedirectComponent, data: {noUrlCache: true}},
  {path: 'login', component: LoginPageComponent, data: {noUrlCache: true}},

  {path: '**', component: NotFoundPageComponent, data: {noUrlCache: true}},
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
